import { Button } from '../../components/ui/Button';

export function RecoveryCodesScreen({ codes, onDone }: { codes: string[]; onDone: () => void }) {
  return (
    <section className="w-full max-w-sm rounded-xl border border-[var(--co-border)] bg-[var(--co-surface)] p-6 shadow-sm flex flex-col gap-4">
      <header className="mb-2">
        <h1 className="text-xl font-semibold">Recovery codes</h1>
        <p className="text-sm text-[var(--co-muted)]">
          Store these codes somewhere safe. Each works once if you lose access to your authenticator. They are shown only now.
        </p>
      </header>
      <ul className="grid grid-cols-2 gap-2 font-mono text-sm">
        {codes.map((code) => (
          <li key={code}>
            <code>{code}</code>
          </li>
        ))}
      </ul>
      <Button type="button" onClick={onDone}>
        I saved my recovery codes
      </Button>
    </section>
  );
}
